import React, { useEffect, useState } from "react";
import Banner from "./../banner/banner";
import LeftSponsers from "./../leftSponsers/leftSponsers";
import PhotographerProfile from "./photgrapherProfile";
import * as api from "./../../api/api";
import * as c from "./../../const";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

//ICONS
import LanguageIcon from "@material-ui/icons/Language";
import PersonIcon from "@material-ui/icons/Person";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

export default function Gallery() {
  const classes = useStyles();
  const [gallery, setGallery] = useState("");
  const [loader, setLoader] = useState(true);
  const [banner, setBanner] = useState("");
  const [showProfile, setShowProfile] = useState(false);
  useEffect(() => {
    document.title = "121five.com - Gallery";
    window.scrollTo(0, 0);
    galleryApi();
  }, []);

  const galleryApi = async () => {
    try {
      let response = await api.gallery();
      let res = await api.banner(3);
      if (res) {
        setBanner(res.image);
      }
      if (response) {
        setGallery(response);
        setLoader(false);
      }
    } catch (e) {}
  };
  return (
    <div>
      <Banner img={banner} />
      <section className="sponsor py-5">
        <div className="container">
          <div className="row justify-content-lg-between justify-content-center">
            <div className="col-lg-3 col-md-6">
              <div className="left-sponsor">
                <LeftSponsers />
              </div>
            </div>

            <div className="col-lg-9 col-md-12">
              <div id="lightbox" className="lightbox py-5">
                <PhotographerProfile />
              </div>
            </div>
          </div>
        </div>
        <Backdrop className={classes.backdrop} open={loader}>
          <CircularProgress />
        </Backdrop>
      </section>
    </div>
  );
}
